// extracted by mini-css-extract-plugin
export default {"title":"DMActionsModal_title__wxg29"};